module.exports = __webpack_public_path__ + "static/media/iconReporteHistorico.5c526710.png";